import {OktaAuth} from '@okta/okta-auth-js'
import appConfig from '@/config'
const oktaConfig = require('@dxp-common-config/global/okta.config.js')
let oktaAuth = {}

if (process.env.VUE_APP_OFFLINE !== 'true') {
  const customAuthUrl = `${appConfig.oktaHostedUrl}/oauth2/${appConfig.authorizationServer}/v1`

  oktaAuth = new OktaAuth({
    issuer: `${appConfig.oktaOrgUrl}/oauth2/${appConfig.authorizationServer}`,
    clientId: appConfig.clientId,
    redirectUri: `${window.location.origin}${process.env.VUE_APP_PUBLIC_PATH}/implicit/callback`,
    postLogoutRedirectUri: `${window.location.origin}${process.env.VUE_APP_PUBLIC_PATH}`,
    scopes: oktaConfig.scopes,
    pkce: true,
    authorizeUrl: `${customAuthUrl}/authorize`,
    userinfoUrl: `${customAuthUrl}/userinfo`,
    logoutUrl: `${customAuthUrl}/logout`
  })
}
export default oktaAuth
